import { InMemoryCache } from '@apollo/client';
import { GET_UPDATE_LEGACY_PROFILE_TOKEN } from 'graphqls/profile';

export const initializeUpdateLegacyProfileToken = (cache: InMemoryCache): void => {
  cache.writeQuery({
    query: GET_UPDATE_LEGACY_PROFILE_TOKEN,
    data: {
      updateLegacyProfileToken: {
        access: '',
        refresh: '',
      },
    },
  });
};

export default {
  resolvers: {
    Mutation: {
      setUpdateLegacyProfileToken: (_, args, { cache }): null => {
        cache.writeQuery({
          query: GET_UPDATE_LEGACY_PROFILE_TOKEN,
          data: {
            updateLegacyProfileToken: args.updateLegacyProfileToken,
          },
        });

        return null;
      },
    },
  },
};
